<div class="kz-plan3D-fullscreen" data-tab="dashboard">
  <div class="kz-plan3D-fs--main">
    <!-- Main - Medias -->
    <app-kazaplan-fullscreen-diapo></app-kazaplan-fullscreen-diapo>
  </div>

  <div class="kz-plan3D-fs--sidebar">
    <button class="kz-plan3D-fs--menu-close" (click)="closeDialog(closureType.Cross)"><kz-icons name="cross"></kz-icons></button>

    <!-- Sidebar - Medias -->
    <app-kazaplan-fullscreen-sidebar-medias></app-kazaplan-fullscreen-sidebar-medias>
  </div>
</div>
